var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_85_15849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 32,
    height: 32,
    rx: 3.92,
    fill: "#2867B2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_15849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.019 5.73828H7.97644C7.01634 5.73828 6.24 6.49625 6.24 7.43338V27.5586C6.24 28.4957 7.01634 29.2583 7.97644 29.2583H28.019C28.9791 29.2583 29.76 28.4957 29.76 27.5632V7.43338C29.76 6.49625 28.9791 5.73828 28.019 5.73828ZM13.2179 25.7808H9.72666V14.5537H13.2179V25.7808ZM11.4723 13.024C10.3514 13.024 9.44644 12.119 9.44644 11.0027C9.44644 9.88644 10.3514 8.98147 11.4723 8.98147C12.5886 8.98147 13.4935 9.88644 13.4935 11.0027C13.4935 12.1144 12.5886 13.024 11.4723 13.024ZM26.2825 25.7808H22.7959V20.3234C22.7959 19.0234 22.7729 17.3467 20.9813 17.3467C19.1668 17.3467 18.8912 18.7662 18.8912 20.2316V25.7808H15.4091V14.5537H18.7534V16.088H18.7993C19.2633 15.206 20.4025 14.2735 22.0976 14.2735C25.6302 14.2735 26.2825 16.5979 26.2825 19.6206V25.7808V25.7808Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_85_15849",
    x: 0.693333,
    y: 0.846667,
    width: 34.6133,
    height: 34.6133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.653333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.653333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_15849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_15849",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_15849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.52,
    height: 23.52,
    fill: "white",
    transform: "translate(6.24 5.73828)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6619e5f1c01a0288581c9747cd9b14b3.svg";
export { ForwardRef as ReactComponent };